import type { ColumnDef } from "@tanstack/react-table";
import { cn } from "@/lib/utils";
import type { BackupDrill, BackupDrillStatus } from "@/lib/backupDrills.api";
import { formatDateTime, statusTone } from "./backups.helpers";

const DRILL_STATUS_LABELS: Record<BackupDrillStatus, string> = {
  running: "En cours",
  success: "Réussi",
  failed: "Échoué",
};

function DrillStatusBadge({ status }: { status: BackupDrillStatus }) {
  const tone = statusTone(status);
  return (
    <span
      className={cn(
        "inline-block rounded px-2 py-0.5 text-[10.5px] font-semibold",
        tone === "danger" && "bg-danger-bg text-danger-text",
        tone === "warning" && "bg-warning-bg text-warning-text",
        tone === "neutral" && "bg-surface-muted text-body",
      )}
    >
      {DRILL_STATUS_LABELS[status]}
    </span>
  );
}

export function createRestoreDrillColumns(): ColumnDef<BackupDrill, any>[] {
  return [
    {
      accessorKey: "startedAt",
      header: "Date / heure",
      cell: ({ row }) => (
        <span className="text-[12px] text-body">{formatDateTime(row.original.startedAt)}</span>
      ),
    },
    {
      accessorKey: "backupId",
      header: "Sauvegarde",
      cell: ({ row }) => (
        <span className="text-[12px] text-body">#{row.original.backupId}</span>
      ),
    },
    {
      accessorKey: "status",
      header: "Statut",
      cell: ({ row }) => <DrillStatusBadge status={row.original.status} />,
    },
    {
      id: "errorMessage",
      header: "Détail",
      cell: ({ row }) => {
        const { errorMessage } = row.original;
        if (!errorMessage) return <span className="text-[12px] text-muted-foreground">—</span>;
        return (
          <span className="text-[12px] text-danger-text" title={errorMessage}>
            {errorMessage.slice(0, 80)}
            {errorMessage.length > 80 ? "…" : ""}
          </span>
        );
      },
    },
  ];
}
